import { addUserRfidCard } from '../../../api/users';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const useAddUserRfidCard = (options?: Omit<UseMutationOptions, 'mutationFn'>) => {
  return useMutation({
    mutationFn: addUserRfidCard,
    ...options,
  });
};

export default useAddUserRfidCard;
